import * as AnalyticsService from "./AnalyticsService";

function trackOrdersPageLoad(user) {
  AnalyticsService.trackPageLoadEvent("fv:emp:customer handling", user);
}

function trackFilterToggle(filterName, isChecked, user) {
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    `emp:customer handling:content:${filterName}:toggle:${
      isChecked ? "on" : "off"
    }`,
    `fv:emp:customer handling:content action`,
    user
  );
}

function trackFilterApplied(filterType, filterValue, user) {
  // Map the filter type to the proper category and subcategories
  let filterString;
  switch (filterType) {
    case "orderRequestType": {
      const typeMap = {
        "purchase-request": "purchase request",
        "pre-order": "pre-order",
      };
      filterString = `filter:order request type:${
        typeMap[filterValue] || filterValue
      }`;
      break;
    }
    case "vehicleSource": {
      const sourceMap = {
        "in-stock": "in stock",
        pipeline: "from plant",
        "in-transit": "in transit",
        "retail-order": "retail order",
      };
      filterString = `filter:vehicle source:${
        sourceMap[filterValue] || filterValue
      }`;
      break;
    }
    case "orderStatus": {
      const statusMap = {
        created: "created",
        accepted: "accepted",
        canceled: "canceled",
      };
      filterString = `filter:order status:${
        statusMap[filterValue] || filterValue
      }`;
      break;
    }
    default: {
      filterString = `filter:${filterType}:${filterValue}`;
    }
  }

  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    `emp:customer handling:content:${filterString}`,
    "fv:emp:customer handling:content action",
    user
  );
}

function trackSortingChange(sortValue, user) {
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    `emp:customer handling:content:sort:${sortValue}`,
    "fv:emp:customer handling:content action",
    user
  );
}

function trackCopyAction(columnId, user) {
  const columnMap = {
    orderIdString: "order number",
    vin: "vin",
  };
  const copyTypeString = `${columnMap[columnId]}:copy`;
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    `emp:customer handling:content:${copyTypeString}`,
    "fv:emp:customer handling:content action",
    user
  );
}

function trackOpenFilters(user) {
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    "emp:customer handling:content:open filters",
    "fv:emp:customer handling:content action",
    user
  );
}

function trackClearFilters(user) {
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    "emp:customer handling:content:clear filters",
    "fv:emp:customer handling:content action",
    user
  );
}

function trackRefreshPage(user) {
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    "emp:customer handling:content:try again",
    "fv:emp:customer handling:content action",
    user
  );
}

function trackLoadMoreAction(user) {
  AnalyticsService.trackOnClickEvent(
    "fv:emp:customer handling",
    "emp:customer handling:content:load more orders",
    "fv:emp:customer handling:content action",
    user
  );
}

export {
  trackOrdersPageLoad,
  trackFilterToggle,
  trackFilterApplied,
  trackSortingChange,
  trackCopyAction,
  trackClearFilters,
  trackRefreshPage,
  trackOpenFilters,
  trackLoadMoreAction,
};
